import * as actionTypes from "./ActionTypes";

export const toggleLoadingAction = (loading) => {
  return { type: actionTypes.TOGGLE_LOADING, loading };
};

export const userMustLoginAction = (state) => {
  return { type: actionTypes.USER_MUST_LOGIN, state };
};

export const clearStateAction = (state) => {
  return { type: actionTypes.CLEAR_AUTH_STATE, state };
};


export const getCurrentUserAction = () => {
  return { type: actionTypes.GET_CURRENT_USER };
};
export const getCurrentUserSuccessAction = (res) => {
  return { type: actionTypes.GET_CURRENT_USER_SUCCESS, res };
};
export const getCurrentUserFailAction = (error) => {
  return { type: actionTypes.GET_CURRENT_USER_FAIL, error };
};

export const loginDispatcherAction = (data) => {
  return { type: actionTypes.LOGIN_USER, data };
};
export const loginDispatcherSuccessAction = (res) => {
  return { type: actionTypes.LOGIN_USER_SUCCESS, res };
};
export const loginDispatcherFailAction = (error) => {
  return { type: actionTypes.LOGIN_USER_FAIL, error };
};

export const checkUserNameExistAction = (data) => {
  return { type: actionTypes.CHECK_USERNAME_EXIST, data };
};
export const checkUserNameExistSuccessAction = (res) => {
  return { type: actionTypes.CHECK_USERNAME_EXIST_SUCCESS, res };
};
export const checkUserNameExistFailAction = (error) => {
  return { type: actionTypes.CHECK_USERNAME_EXIST_FAIL, error };
};

export const loginUserByKeyAction = (data) => {
  return { type: actionTypes.LOGIN_USER_BY_KEY, data };
};
export const loginUserByKeySuccessAction = (res) => {
  return { type: actionTypes.LOGIN_USER_BY_KEY_SUCCESS, res };
};
export const loginUserByKeyFailAction = (error) => {
  return { type: actionTypes.LOGIN_USER_BY_KEY_FAIL, error };
};

export const getHelpicalTokenAction = (data) => {
  return { type: actionTypes.GET_HELPICAL_TOKEN, data };
};
export const getHelpicalTokenSuccessAction = (res) => {
  return { type: actionTypes.GET_HELPICAL_TOKEN_SUCCESS, res };
};
export const getHelpicalTokenFailAction = (error) => {
  return { type: actionTypes.GET_HELPICAL_TOKEN_FAIL, error };
};